import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';

import { callApi } from 'utils';
import { Popup } from 'components';
import { t } from 'i18n';

const idname = {
  'o': 'OAID',
  'i': 'IMEI',
  'a': 'IDFA',
};

const DeviceCheck = ({job, onClose}) => {
  const [result, setResult] = useState({key: '', device: null, error: ''});
  const [nth, setNth] = useState(0);

  useEffect(() => {
    if (!job) {
      setResult({key: '', device: null, error: ''});
      return undefined;
    }

    const key = `${job.fc_id}:${nth}`;
    setResult({key, device: null, error: ''});
    let active = true;
    callApi(`/jobs/${job.fc_id}/device`)
      .then(device => {
        const error = device?.did ? '' : t('No device found');
        active && setResult({key, device: error ? null : device, error});
      })
      .catch(ex => {
        console.error(ex);
        active && setResult({key, device: null, error: ex.message || String(ex)});
      });
    return () => {
      active = false;
    };
  }, [job, nth]);

  const getAnother = useCallback(() => setNth(n => n + 1), []);

  if (!job)
    return null;

  const resultKey = `${job.fc_id}:${nth}`;
  const device = result.key === resultKey ? result.device : null;
  const error = result.key === resultKey ? result.error : '';
  const did = device?.did || '';
  const loading = !device && !error;

  return (
    <Popup
      open={Boolean(job)}
      onClose={onClose}
      title={`${job.id} - ${job.name} (${job.prepared})`}
      styles={{width: '600px'}}
    >
      {loading && (
      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, py: 2}}>
        <CircularProgress size={24} />
        <span>{t('Loading')}</span>
      </Box>
      )}
      {error && (
      <Typography color="error" sx={{mt: 2}}>{error}</Typography>
      )}
      {device && (
      <Typography>
        <p>Device: {device.make + ' ' + device.model}</p>
        <p>OS: {device.os + ' ' + device.osv}</p>
        <p>{idname[did[0]] || 'DID'}: {did.substr(2)}</p>
        <p>User-Agent: {device.ua}</p>
      </Typography>
      )}
      <Button disabled={loading} onClick={getAnother}>{t('Check Another')}</Button>
    </Popup>
  );
};

export default DeviceCheck;
